
import { Link } from 'react-router-dom';

export function ProductCategoriesGrid() {
  const categories = [
    {
      id: 'flaggen',
      name: 'Flaggen',
      description: 'Professionelle Fahnen & Banner für jeden Anlass - von Beachflags bis Fahnenmasten',
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/c855409a3c1c7a24614b3bea9190655c.jpeg',
      bgColor: 'bg-amber-50',
      hoverColor: 'hover:bg-amber-100',
      href: '/flaggen',
      icon: 'ri-flag-line'
    },
    {
      id: 'werbung',
      name: 'Werbung',
      description: 'Werbemittel & Displays für maximale Sichtbarkeit - Rollups, Banner & mehr',
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/0af6fdd7cdf8e6701304fc516be5180d.jpeg',
      bgColor: 'bg-emerald-50',
      hoverColor: 'hover:bg-emerald-100',
      href: '/werbung',
      icon: 'ri-advertisement-line'
    },
    {
      id: 'promotion',
      name: 'Promotion',
      description: 'Promotion-Artikel & Giveaways für Events - Werbeartikel mit Ihrem Logo',
      image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/0aa409769ec7685a762e2f5a29a1e422.jpeg',
      bgColor: 'bg-rose-50',
      hoverColor: 'hover:bg-rose-100',
      href: '/promotion',
      icon: 'ri-gift-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <div className="inline-block px-4 py-2 bg-zinc-800 text-white rounded-full text-sm font-semibold uppercase tracking-wider mb-6">
            Unser Sortiment
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-zinc-800 leading-tight max-w-4xl mx-auto">
            <span className="block">Professionelle Lösungen für</span>
            <span className="block text-gray-600">Ihre Marke</span>
          </h2>
          <p className="text-xl text-gray-600 mt-6 max-w-2xl mx-auto">
            Entdecken Sie unser umfassendes Angebot an Flaggen, Werbemitteln und Promotion-Artikeln
          </p>
        </div>

        {/* Products Grid - 3 Categories */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <Link
              key={category.id}
              to={category.href}
              className={`group relative overflow-hidden rounded-2xl ${category.bgColor} ${category.hoverColor} transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Product Image */}
              <div className="aspect-w-4 aspect-h-3 p-6 pb-0">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-56 object-cover object-center rounded-xl shadow-md group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-sm mr-3">
                    <i className={`${category.icon} text-xl text-zinc-800`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-zinc-800 group-hover:text-zinc-900 transition-colors">
                    {category.name}
                  </h3>
                </div>
                <p className="text-gray-600 text-base leading-relaxed mb-4">
                  {category.description}
                </p>
                
                {/* Arrow Icon */}
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-zinc-700 uppercase tracking-wider">
                    Mehr erfahren
                  </span>
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-sm group-hover:bg-zinc-800 group-hover:text-white transition-all duration-300">
                    <i className="ri-arrow-right-line text-lg transform group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </div>
              </div>

              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
            </Link>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <p className="text-lg text-gray-600 mb-8">
            Individuelle Lösungen für Ihr Unternehmen
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-4 bg-zinc-800 text-white font-semibold rounded-lg hover:bg-zinc-900 transition-colors whitespace-nowrap"
            >
              Individuelle Beratung
              <i className="ri-phone-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
